import config from "react-global-configuration";

const BLOCKED_REDIRECT_PATHS = new Set([
  "/login",
  "/logout",
  "/sso/login",
  "/sso/logout",
  "/sso/callback",
  "/dabella/login",
  "/okta/callback",
  "/okta/logout",
  "/404",
  "/403",
]);

export const stripBasePath = (pathname: string): string => {
  const basePath = config.get("BASE_PATH");

  if (basePath && pathname.startsWith(basePath)) {
    return pathname.replace(basePath, "/");
  }

  return pathname;
};

export const withBasePath = (pathname: string): string => {
  const basePath = config.get("BASE_PATH");

  return basePath ? basePath.replace(/\/$/, "") + pathname : pathname;
};

export const getRedirectPath = (search: URLSearchParams) => {
  const raw = search.get("redirectTo") || "";

  if (!raw) return "/";
  if (URL.canParse(raw)) return "/";
  if (!URL.canParse(raw, window.location.origin)) return "/";

  const url = new URL(raw, window.location.origin);
  if (url.origin !== window.location.origin) return "/";

  // The router already mounts under BASE_PATH, so strip it once over the whole value.
  const relativePath = stripBasePath(url.pathname) + url.search + url.hash;
  if (
    !URL.canParse(relativePath, window.location.origin) ||
    new URL(relativePath, window.location.origin).origin !== window.location.origin
  ) {
    return "/";
  }

  const [pathname] = relativePath.split(/[?#]/);
  // React Router matches routes case-insensitively, so /LOGOUT reaches the route the blocklist names.
  const normalized = pathname.replace(/(.)\/+$/, "$1").toLowerCase();

  if (BLOCKED_REDIRECT_PATHS.has(normalized)) {
    return "/";
  }

  return relativePath;
};
